'use client';
import React, { useState } from 'react';
import { PlayCircleIcon } from '@heroicons/react/24/solid';
import { ModalVideoPlayer } from '@/components/ModalVideoPlayer';
import { copyProductDemo } from '@/sections/develocity/ProductDemoSection/productDemoSection.copy';
import { useHeroRevealAnimation } from './useHeroRevealAnimation';

export const ProductDemoSection = () => {
  const ref = React.useRef<HTMLDivElement>(null);
  const { title, subtitle, videoLink, button } = copyProductDemo;
  const [isOpen, setOpen] = useState<boolean>(false);

  const openModal = () => {
    setOpen(true);
  };

  const closeModal = () => {
    setOpen(false);
  };

  // Setup Scroll reveal Parallax Animation
  useHeroRevealAnimation(ref);

  return (
    <div
      className="hero relative z-10 bg-gradient-to-br from-primary to-secondary px-4 py-32 text-white will-change-transform"
      ref={ref}
    >
      <div className="hero-content text-center">
        <div className="max-w-full">
          <h1 className="mb-5 text-h3-sm font-bold lg:text-h1-sm xl:text-h1-lg">{title}</h1>
          <p className="mx-auto mb-10 max-w-5xl text-body-sm md:text-eyebrow-md lg:text-h5-sm xl:text-eyebrow-xl">
            {subtitle}
          </p>
          <button
            className="btn gap-2 bg-white font-semibold uppercase text-black hover:bg-light-background-200"
            onClick={openModal}
          >
            <PlayCircleIcon className="size-6" />
            {button}
          </button>
          <ModalVideoPlayer isOpen={isOpen} videoLink={videoLink} onClose={closeModal} />
        </div>
      </div>
    </div>
  );
};
